/**
 * 請求する月数の上限を計算する関数
 * @param unitPrice
 * @param maximumPrice
 * @returns {number}
 * @throws {RangeError} unitPrice が 0 以下の場合
 */
export const calculateLimitMonth = (
  unitPrice: number,
  maximumPrice: number
): number => {
  if (unitPrice <= 0) {
    // ここには到達しない想定だが、念のためエラーハンドリングを追加
    throw new RangeError("unitPriceは0より大きい値を指定してください");
  }
  return Math.floor(maximumPrice / unitPrice);
};
